import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import SpinnerButton from 'src/components/SpinnerButton';
import TooltipWrapper from 'src/components/TooltipWrapper';

export default class SaveNewVersion extends PureComponent {
    render() {
        const { text, spinning, saveAsNewVersion, disabled, tip } = this.props;
        return (
            <div className='tools-save'>
                <TooltipWrapper direction='top' contents={tip}>
                    <SpinnerButton
                        testid='editor-footer-save-new-version'
                        onClick={saveAsNewVersion}
                        text={text}
                        disabled={disabled || !!tip}
                        spinning={spinning}
                    />
                </TooltipWrapper>
            </div>
        );
    }
}

SaveNewVersion.propTypes = {
    disabled: PropTypes.bool,
    spinning: PropTypes.bool,
    text: PropTypes.string,
    tip: PropTypes.string,
    saveAsNewVersion: PropTypes.func.isRequired,
};

SaveNewVersion.defaultProps = {
    tip: '',
};
